import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * The view's one <h1>. Visually hidden by default: the sidebar (and the
 * mobile header) already name the view, so a visible h1 would restate a label.
 */
export function PageHeading({ children, visible = false, className }: { children: ReactNode; visible?: boolean; className?: string }) {
  return <h1 className={cn(visible ? 'm-0 text-xl font-semibold tracking-tight' : 'sr-only', className)}>{children}</h1>;
}
